import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { IsNotEmpty, IsOptional, IsString, MaxLength } from 'class-validator';

export class EnviarMensajeDto {
  @ApiProperty({ description: 'Pregunta en lenguaje natural' })
  @IsString()
  @IsNotEmpty()
  @MaxLength(1000)
  pregunta: string;
}

export class GuardarFavoritoDto {
  @ApiProperty({ description: 'ID del mensaje de IA del cual crear el favorito' })
  @IsString()
  @IsNotEmpty()
  mensaje_id: string;

  @ApiPropertyOptional({ description: 'Título descriptivo (opcional, si no se usa el de la sesión)' })
  @IsOptional()
  @IsString()
  @MaxLength(200)
  titulo?: string;
}
